import { React, useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Route, Routes, useLocation } from 'react-router-dom';
import { createBrowserHistory } from 'history';

//comman component
import Space from "./space/Space.js"
import SubmittedPage from "./submitted/submittedPage"
import { ASSET_FORM_TYPE, SPACE_FORM_TYPE } from '../constants/stringConstants'
import EmailComponent from './email/emailPage.js';
import ErrorComponent from './space/errorComponent.js';
import ErrorPage from './ErrorPage/ErrorPage.js';
import MaintenancePage from './maintanence/maintenancePage.js';
import EmailVerification from './emailVerification/emailVerification.js'
import Qrcode from './qrcode/qrcode.js'
import Loader from '../layouts/loader/index';
import { openAuthenticationTab } from './storage/selectionStorage';

const history = createBrowserHistory();

// Protected QR Code Route Component - moved outside Layout to prevent recreation
const ProtectedQRCode = () => {
  const token = localStorage.getItem("TOKEN");
  const idToken = localStorage.getItem("IdentityToken");
  const qrcodeAuthorized = localStorage.getItem("qrcodeAuthorized") === "true";
  const qrcodeAuthFailed = localStorage.getItem("qrcodeAuthFailed") === "true";
  const hasAuth = Boolean(token || idToken || qrcodeAuthorized);
  const isAuthInProgress = localStorage.getItem("isNMBSLoginInitiated") === "true";

  useEffect(() => {
    if (hasAuth) {
      localStorage.setItem("isNMBSLoginInitiated", "false");
      localStorage.removeItem("qrcodeAuthFailed");
      return;
    }

    // Only trigger auth if we're not already in the auth process
    if (isAuthInProgress || qrcodeAuthFailed) {
      return;
    }

    // Preserve intended route and trigger the same NMBS login flow used elsewhere.
    localStorage.removeItem("code_exchange_completed");
    localStorage.removeItem("entra_redirect_in_progress");
    localStorage.removeItem("code");
    localStorage.removeItem("state");
    localStorage.removeItem("qrcodeAuthFailed");
    localStorage.setItem("initialPath", "/qrcode");
    openAuthenticationTab();
  }, [hasAuth, isAuthInProgress, qrcodeAuthFailed]);

  if (!hasAuth && !qrcodeAuthFailed) {
    return <Loader />;
  }

  return <Qrcode />;
};

const Layout = (props) => {
  const location = useLocation();

  const [formType, setFormType] = useState(props.formTypeParam);
  const [assetId, setAssetId] = useState(props.assetId);
  const [isErrorPage, setIsErrorPage] = useState(false);
  const [isEmailPage, setIsEmailPage] = useState(false);
  const [isEmailVerificationPage, setIsEmailVerificationPage] = useState(false);
  const [hashCode, setHashCode] = useState("");
  const [isFMO,setIsFMO] = useState(false);
  const [pathName, setPathName] = useState(props.initialPath ? props.initialPath : window?.location?.pathname)


  const baseUrl = window?.origin;
  let pathNameObjArray = pathName.split("/");

  const parseWindowLocationToRoute = () => {

    if (baseUrl.includes("/")) {
      setIsErrorPage(true);
    } else {
      setIsErrorPage(false);
    }

    setPathName(props.initialPath ? props.initialPath : window?.location?.pathname)
    if (pathNameObjArray.includes("facility-asset")) {
      setFormType(ASSET_FORM_TYPE)
    } else if ((pathNameObjArray.includes("facility-space"))) {
      setFormType(SPACE_FORM_TYPE)
    }

    if (pathNameObjArray.includes("unsubscribe")) {
      setIsEmailPage(true);
      setIsEmailVerificationPage(false);
      setHashCode(pathNameObjArray[pathNameObjArray.length - 1]);
      setIsFMO(pathNameObjArray[pathNameObjArray.length - 2].toLowerCase() === "true");
    } else {

      setIsEmailPage(false);

    }

    if (pathNameObjArray.includes("verify")) {
      setIsEmailVerificationPage(true);
      setIsEmailPage(false);
      setIsFMO(pathNameObjArray[pathNameObjArray.length - 2].toLowerCase() === "true");
    } else {

      setIsEmailVerificationPage(false);

    }


    setAssetId(pathNameObjArray[pathNameObjArray.length - 1]);




  }


  const languageCode = localStorage.getItem("languageCode")

  useEffect(() => {
    // Keep layout route parsing in sync after callback -> dynamic URL navigation.
    // Runs whenever the browser path changes (e.g. from /qrcode to /facility-space/xxx).
    const currentPath = props.initialPath || window.location.pathname;
    const segments = currentPath.split("/");

    setPathName(currentPath);
    setAssetId(segments[segments.length - 1]);

    if (segments.includes("facility-asset")) {
      setFormType(ASSET_FORM_TYPE);
    } else if (segments.includes("facility-space")) {
      setFormType(SPACE_FORM_TYPE);
    } else if (!segments.includes("qrcode") && !segments.includes("local")) {
      // Only reset formType when clearly not a form path (don't reset for qrcode routes)
      setFormType(null);
    }
  }, [location.pathname, props.initialPath]);

  const mounted = useRef();
  useEffect(() => {
    if (!mounted.current) {
      // do componentDidMount logic
      console.log("do componentDidMount logic");
      parseWindowLocationToRoute()

      mounted.current = true;
    } else {
      parseWindowLocationToRoute()
      console.log("do componentDidUpdate logic");

      // do componentDidUpdate logic
    }
  }, [assetId, pathName]);




  return (
    <Routes history={history}>
      {formType && <Route path={pathName} element={<Space formType={formType} assetId={assetId} langCode={languageCode} />} ></Route>}
      <Route path="/submitted" element={<SubmittedPage />} />
      <Route path="/errorPage" element={<ErrorComponent langCode={languageCode} />} />
      {isEmailPage && <Route path={pathName} element={<EmailComponent hashCode={hashCode} langCode={languageCode} isFMO={isFMO}/>} />}
      {isEmailVerificationPage && <Route path={pathName} element={<EmailVerification isFMO={isFMO} />} />}
      <Route path="/serverDown" exact={true} element={<ErrorPage />} />
      <Route path="/maintenance" exact={true} element={<ErrorPage isPlannedMaintenance={true} />} />
      <Route path="/qrcode" exact={true} element={<ProtectedQRCode />} />

      {isErrorPage && <Route path="/" exact={true} element={<MaintenancePage />} />}
    </Routes>
  );
}

Layout.propTypes = {
  formTypeParam: PropTypes.string,
  assetId: PropTypes.string,
  initialPath: PropTypes.string
};

export default Layout;
